// filterURL keys
export const KEY_URL_SEARCH = "s";
export const KEY_URL_CATEGORY = "cat";
export const KEY_URL_PRICE_MIN = "prMin";
export const KEY_URL_PRICE_MAX = "prMax";
export const KEY_URL_AVAILABLE = "avail";
export const KEY_URL_RATING = "rat";
export const KEY_URL_BID_TYPE = "bdT";
export const KEY_URL_STATUS = "stat";
export const KEY_URL_DATE_MIN = "dtMin";
export const KEY_URL_DATE_MAX = "dtMax";
export const KEY_URL_AUCTION_ID = "auctID";
export const KEY_URL_DAYS_LEFT = "dLeft";
export const KEY_URL_PAID = "pd";
export const KEY_URL_COURIER = "cor";
export const KEY_URL_TRACKING = "trak";
export const KEY_URL_WON_BY = "wonBy";
export const KEY_URL_SORT = "srt";

// Sorting options
export const KEY_SORT_RELEVANCE: "rel" = "rel";
export const KEY_SORT_NEWEST: "new" = "new";
export const KEY_SORT_PRICE_ASC: "prAsc" = "prAsc";
export const KEY_SORT_PRICE_DESC: "prDesc" = "prDesc";
export const KEY_SORT_RATING: "rat" = "rat";

export const TIMEOUT_FILTERS = 800;

export const MIN_ALLOWED_TIME_LEFT = -3;

// UUID
export const DEVICE_ID_KEY = "device_id";

// AI Chat
export const AI_CHAT_LOCAL_STORAGE_KEY = "chat-data";
// Max time to show notification on a single window
export const AI_NOTIFICATION_DISPLAY_TIME = 30 * 1000; // 30 seconds (measure = milliseconds)
// delay for when a notification should be shown to the user
export const AI_CHAT_NOTIFICATION_DELAY = 3000; // 3 seconds (measure = milliseconds)
// time to wait for network response for messages
export const AI_CHAT_ALLOWED_MAX_WAIT_TIME = 1000 * 30; // 30 seconds (measure = milliseconds)
// max number of messages that can be in the queue
export const AI_CHAT_MESSAGE_LIMIT = 5;
// frequency to check for updated user data
export const AI_CHAT_UPDATE_INTERVAL = 2 * 60 * 1000; // 2 minutes (measure = seconds)
// duration for Jayda popup for to pulse
export const AI_NOTIFICATION_PULSE_TIME = 1000 * 60 * 3; // 3 minutes (measure = milliseconds)
